import { ConnectorIcons } from '@/lib/connectorIcons';

/** A connector's logo at any size. The logos are drawn at 32px; this scales them. */
export function ConnectorLogo({ type, size = 16, title }: { type: string; size?: number; title?: string }) {
  const icon = ConnectorIcons[type];
  if (!icon) return null;
  return (
    <span
      aria-hidden={title ? undefined : true}
      role={title ? 'img' : undefined}
      aria-label={title}
      className="inline-flex shrink-0 align-middle [&>svg]:h-full [&>svg]:w-full"
      style={{ width: size, height: size }}
    >
      {icon}
    </span>
  );
}
